import { DropdownWithoutOptionsProps } from "components/dropdowns/models";
import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";
import React from "react";
import { TimeOption, timeOptions } from "../models";

const UpcomingShowsDropdown = (props: DropdownWithoutOptionsProps<number, TimeOption>) =>
  <BaseReactSelectDropdown
    excludeKeys={[]}
    options={timeOptions}
    value={timeOptions.find(o => o.value === props.value)}
    onChange={v => { props.onChange(v.value); }}
    getLabel={o => o.text}
    getValue={o => o.value}
    config={{
      isSearchable: false,
      shouldRenderSelectedValue: true,
      ...props.config,
    }}
  />

export default UpcomingShowsDropdown;
